import PageTabTitle from "../../../global/components/PageTabTitle/PageTabTitle.vue";
import ProjektberichtVorlagenModalCreate from "../ProjektberichtVorlagenModalCreate/ProjektberichtVorlagenModalCreate.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";
import SmartTable from "../../../global/components/table/table.vue";

import getTableApi from "../../../const/TableApis";

const TABLE_ID = "projektberichtvorlage";

// @vue/component
export default {
  name: "ProjektberichtVorlagenList",
  components: {
    PageTabTitle,
    ProjektberichtVorlagenModalCreate,
    PuxTranslate,
    SmartTable,
  },
  data() {
    return {
      tableId: TABLE_ID,
      options: {
        id: TABLE_ID,
        url: getTableApi({ id: TABLE_ID }),
        rowActions: [
          {
            label: "_LBL_PROJEKTBERICHT_VORLAGEN_LIST_ACTIONS_ROW_DETAILS_",
            route: "root.projektberichtvorlagen.detail",
            routeParameters: [{ routeId: "id", rowPath: "pk" }],
          },
        ],
        actions: [
          {
            permission: "projektberichtvorlage.create",
            label: "_LBL_PROJEKTBERICHT_VORLAGEN_LIST_PROJEKTBERICHTVORLAGE_ERSTELLEN_",
            callback: () => this.modal.create = true,
            type: "button",
            className: "btn btn-primary",
            icon: "glyphicon-plus",
            htmlId: "projektberichtvorlage_create",
          },
        ],
        label: "_LBL_PROJEKTBERICHT_VORLAGEN_LIST_PROJEKTBERICHTVORLAGEN_",
        sortable: true,
        pagination: true,
        details: false,
        view: {
          filter: "top",
        },
      },
      modal: {
        create: undefined,
      },
    };
  },
  methods: {
    closeModalCreate() {
      this.modal.create = false;
    },
  },
};
